import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog,
  MatDialogConfig, MatDialogRef
} from '@angular/material/dialog';
import { TagCategoryInfoFragment } from 'generated/graphql';

/**
 * Format of data for the dialog
 */
export interface ApplyTagWithFieldSelectDialogData {
  campaignId: string;
  /** Is it for EntityType or EntityConnectionType? */
  targetType: 'EntityType' | 'EntityConnectionType' | 'CalendarEventType';

  /** The EntityTypeId or the EntityConnectionTypeId */
  targetTypeId: string;

  /** The id of the entity or the connection */
  targetId: string;
}

/**
 * Used to add info when the field (tag category)
 * is not yet known.
 */
@Component({
  selector: 'app-apply-tag-with-field-select-dialog',
  templateUrl: './apply-tag-with-field-select.dialog.html'
})
export class ApplyTagWithFieldSelectDialog {
  selectedCategory: TagCategoryInfoFragment;

  get entityOrConnection() {
    if (this.data.targetType === 'CalendarEventType') { return 'CalendarEventResponse'; }
    return this.data.targetType === 'EntityConnectionType' ? 'EntityConnection' : 'Entity';
  }

  public static open(dialog: MatDialog, config: MatDialogConfig<ApplyTagWithFieldSelectDialogData>) {
    return dialog.open(ApplyTagWithFieldSelectDialog, { ...config, ...{ disableClose: true } });
  }

  /**
   *
   */
  constructor(
    public dialogRef: MatDialogRef<ApplyTagWithFieldSelectDialog>,
    @Inject(MAT_DIALOG_DATA) public data: ApplyTagWithFieldSelectDialogData
  ) {
    if (!['EntityConnectionType', 'EntityType', 'CalendarEventType'].includes(data.targetType)) {
      throw new Error('Invalid TargetType provided');
    }
  }

  close() {
    this.dialogRef.close();
  }

  setCategory(category: any) {
    this.selectedCategory = category;
  }
}
